
import Config from '../model/Config.js';
import Provider from '../model/Provider.js'
import { device } from './deviceCheck.js';
import { providerChk } from './provider.id.check.js';


export const mobileFn = {
  setKakaoCallbackUrl : ()=>{
      if(Provider.deviceInfo.code == "MO"){
          return setKakaoCallback();
      }else{
        if(Provider.deviceInfo.browser == "WBK"){
          return setKakaoCallback();
        }
      }
      return true;
  },
  moveLinkByProvider: ()=>{
      if(Provider.deviceInfo.code == "MO"){
          call.callByProvider(Provider.providerId);
      }else{
        if(Provider.deviceInfo.browser == "WBK"){
          if(providerChk.isKakao(Provider.providerId)){
            call.kko();
          }
        }
      }
  }
}

const call = {
  callByProvider: (providerId)=>{
      if(providerChk.isPass(providerId)){
          call.tel_pass();
      }else if(providerChk.isKakao(providerId)){
          call.kko();
      }else if(providerChk.isPayco(providerId)){
          call.payco();
      }else if(providerChk.isSamsung(providerId)){
          call.samsungpass();
        // var msg = "삼성패스 앱이 정상적으로 동작하지 않으면 최신으로 업데이트 바랍니다."
        // viewEvent.view_msg("안내","",msg,);
      }else if(providerChk.isKb(providerId)){
          call.kbbank();
      }else if(providerChk.isToss(providerId)){
          call.toss();
      }else if(providerChk.isNaver(providerId)){
          call.naver();
      }else if(providerChk.isKakaoPay(providerId)){
          call.kakaopay();
      }else if(providerChk.isShinhan(providerId)){
          call.shinhan();
      }else{
        // BankSalad, Hana, 그외 인증기관
        const url = Provider.deeplinkUri;
        if(!!url){
          location.href = url;
        }
      }
  },
  naver:()=>{
      // 일반 브라우저 일 시 인증 후 앱종료
      // 네이버앱일 시 간편인증을 이어서 진행해야하기 때문에 뷰만 종료
      const varUA = navigator.userAgent.toLowerCase();
      const ostype = device.checkMobileType();
      const uriScheme = Provider.naverAppSchemeUrl;
      if(!!uriScheme){

          if(ostype == "IOS") {
            let resStr = uriScheme
            if(!!Config.uriScheme.universalLink){
              resStr = `https://naverapp.m.naver.com/?urlScheme=${encodeURIComponent(uriScheme)}`
              if ( varUA.match("naver") == null) { resStr += '&closeApp=true' }
            }
            location.href = resStr
          }else if(ostype == "AOS"){
              let resStr = uriScheme
              if ( varUA.match("naver") == null) { resStr += '&closeApp=true' }
              location.href = resStr
          }
      }
  },
  shinhan:()=>{
    // TODO 민간 Shinhan 처리
    if(Provider.isEnt()){
      if(!!Provider.deeplinkUri){
        location.href = Provider.deeplinkUri;
        return 
      }
    }

    // 공공
    const ostype = device.checkMobileType();
    const reqTxId = Provider.reqTxId;
    const certTxId = Provider.cxId;
    let resStr = "";
    if(ostype == "IOS") {
        resStr = `iphoneSbank://SHSIGN?tran_type_cd=sol_gov&cert_tx_id=${certTxId}&sign_tx_id=${reqTxId}`
        // 앱호출 연결 웹화면
        if(!!Config.uriScheme.universalLink){
          resStr = `https://sol.shinhan.com/sms.jsp?scrid=SHSIGN&tran_type_cd=sol_gov&cert_tx_id=${certTxId}&sign_tx_id=${reqTxId}`
        }
        location.href = resStr;
    }else if(ostype == "AOS"){
        resStr = `sbankandnor://SHSIGN?tran_type_cd=sol_gov&cert_tx_id=${certTxId}&sign_tx_id=${reqTxId}`
        location.href = resStr;
    }
  },
  kakaopay:()=>{
    var tx_id = Provider.cxId;
    var url = `kakaotalk://kakaopay/cert/sign?tx_id=${tx_id}&success=https://cx.raonsecure.co.kr:27443/ent&fail=https://cx.raonsecure.co.kr:27443/ent`;
    location.href = url;
  },
  kko:()=>{
      const ostype = device.checkMobileType() ;
      var inCxid = Provider.cxId;
      var resStr = "";

      if(Config.uriScheme.mode.id == "dev"){
          //개발
          resStr = "alphatalk://me/cert/sign?tx_id="+inCxid; 
      }else{
          //운영
          if(Config.uriScheme.universalLink !== undefined && Config.uriScheme.universalLink){
              if(ostype == "IOS") {
                  const link = "https://talk-apps.kakao.com/scheme/";
                  const uriScheme = "kakaotalk://me/cert/sign?tx_id="+inCxid; 
                  resStr = link + encodeURIComponent(uriScheme);
              }else {
                resStr = "kakaotalk://me/cert/sign?tx_id="+inCxid;
              }
          }else{
              resStr = "kakaotalk://me/cert/sign?tx_id="+inCxid;
          }
      }
      location.href = resStr;
  },
  payco:()=>{
      const ostype = device.checkMobileType() ;
      var pay_session = Provider.cxId;
      var signAfterExit = "&signAfterExit=true";
      //URISCHEME
      var resStr = "";
      if(ostype == "IOS") {
        if(Config.uriScheme.universalLink !== undefined && Config.uriScheme.universalLink){
            if(Config.uriScheme.mode.id == "dev"){
              //개발
              resStr = `https://paycoiostest.page.link/?link=https%3A%2F%2Fm.payco.com%3Fscheme%3Dpayco%253A%252F%252Fopen%252Fcertificate%253Fsession%3D${pay_session}&ibi=com.nhnent.TOASTPAY.test&isi=924292102&efr=1&ifl=https%3A%2F%2Fm.payco.com%2Fapp%2Fexec.nhn%3Fopen%3D%252Fcertificate%253Fsession%3D${pay_session}`
            }else{
              //운영
              resStr = `https://paycoiosmarket.page.link/?link=https%3A%2F%2Fm.payco.com%3Fscheme%3Dpayco%253A%252F%252Fopen%252Fcertificate%253Fsession%3D${pay_session}&ibi=com.nhnent.TOASTPAY&isi=924292102&efr=1&ifl=https%3A%2F%2Fm.payco.com%2Fapp%2Fexec.nhn%3Fopen%3D%252Fcertificate%253Fsession%3D${pay_session}`
            }
        }else{
            resStr ="payco://open/certificate?session="+pay_session + signAfterExit;
        }
      }else {
          resStr ="payco://open/certificate?session="+pay_session + signAfterExit;
      }
      location.href = resStr;
  },
  kbbank:()=>{
      // alert("KB은행 호출");
      location.href = makeKbData();
  },
  tel_pass:()=>{
      var telcoTycd = Provider.userInfo.telcoTycd;
      if(telcoTycd == "S"){
          // alert("PASS SKT 호출");
      }else if (telcoTycd == "K"){
          // alert("PASS KT 호출");
      }else if(telcoTycd == "L"){
          // alert("PASS LGU+ 호출");
      }
      var resStr = makePassData();
      // alert("call : "+resStr);
      location.href = resStr;
  },
  samsungpass:()=>{
      // alert("삼성PASS 호출");
      const deeplinkUri = Provider.deeplinkUri;
      // alert("call : " + deeplinkUri);
      if(deeplinkUri != ""){
        // alert("deeplinkUri: "+deeplinkUri);
        location.href = deeplinkUri;
      }
  },
  toss(){
    const ostype = device.checkMobileType() ;
    let url = Provider.deeplinkUri;
    if (!!!url) {
      var tx_id = Provider.cxId;
      // provider id cotoss 사용 시 고정 URI Scheme 호출
      url = `supertoss://toss-cert/v2/sign/user/auth?txId=${tx_id}&_minVerAos=5.36.0&_minVerIos=5.10.0`
    }

    if(ostype == "IOS") {
      if(Config.uriScheme.universalLink !== undefined && Config.uriScheme.universalLink){
        location.href = `https://ul.toss.im?scheme=${encodeURIComponent(url)}`
      }else{
        location.href = url
      }
    }else{
      location.href = url
    }
  }
}

function getKakaoWebVersion(){
  const varUA = navigator.userAgent.toLowerCase();
  if ( varUA.match("kakaotalk") != null) {
    var point = varUA.indexOf('kakaotalk');
    var data = varUA.substring(point+10);
    return data;
  } else {
      return "0";
  }
}

function compareVersion(verA, verB){
  var result = true;
  verA = verA.split( '.' ); // .을 기준으로 문자열 배열로 만든다 [6][8]
  verB = verB.split( '.' ); // .을 기준으로 문자열 배열로 만든다 [6][7][99]

  const length = Math.max( verA.length, verB.length ); // 배열이 긴쪽의 length를 구함

  for ( var i = 0; i < length ; i ++ ){
    var a = verA[i] ? parseInt(verA[i], 10 ) : 0; // 10진수의 int로 변환할 값이 없을 때 0으로 값을 넣습니다.
    var b = verB[i] ? parseInt(verB[i], 10 ) : 0;
    //alert( a +' > ' + b + ' : ' + ( a > b ) );
    if ( a < b ) {
      result = false;
      break;
    }
  }
return result;
}

function setKakaoCallback(){
  const browser_cd = Provider.deviceInfo.browser
  Provider.providerOptionInfo.callbackUrl  = ""
  if(Provider.providerId != "kakao"){
    return true;
  }
  
  if (browser_cd == 'HY' || browser_cd == 'NA') {
    //   alert('설정 Callback URI Scheme');
  }else if (browser_cd == 'WB'){// 210413 WB 이면서 안드이면 CLOSE 셋팅
    if (device.checkMobileType() == "AOS") {
      // alert("callbackUrl : alphatalk://me/talk_close");
      if(Config.uriScheme.mode.id == "dev"){
        Provider.providerOptionInfo.callbackUrl  = "alphatalk://me/talk_close"
      }else{
        Provider.providerOptionInfo.callbackUrl  = "kakaotalk://me/talk_close"
      }
    }
  }// END WB
  else {

    // 카카오브라우저인지 확인
    if (Provider.deviceInfo.browser == "WBK") {
      var kakao_ver = getKakaoWebVersion();
      // alert("kakao_ver :"+kakao_ver);
      if (device.checkMobileType() == "IOS") {
        // 버전체크 - 9.3.0 비교 /
        if (compareVersion(kakao_ver, '9.3.0')) {
          // alert("callbackUrl : empty");
          Provider.providerOptionInfo.callbackUrl = "";
        }else {
          alert("업그레이드 필요");
          return false;
        }
      } else if (device.checkMobileType() == "AOS") {
        // 버전체크 - 2109150 비교
        if (compareVersion(kakao_ver, '2109150')) {
          // alert("callbackUrl is empty");
          Provider.providerOptionInfo.callbackUrl = "";
        }else {
          alert("업그레이드 필요");
          return false;
        }//END VER
      } else {
        //alert('PC');
      }
    }
  }//end test
  
  return true;
}


function makeKbData(){
  const reqid = Provider.reqTxId;
  const certid = Provider.cxId;
  var kbScheme = "";
  
  const ostype = device.checkMobileType() ;
  if(ostype == "IOS") {
    if(Config.uriScheme.mode.id == "dev"){
      kbScheme = "https://mbank.kbstar.com/kbapplink?cmd=move_to&id=web&url=/mquics?page=C102688&urlparam=";
      // kbScheme = "https://ymbank.kbstar.com/kbapplink?cmd=move_to&id=web&url=/mquics?page=C102688&urlparam=";
      // kbScheme = "https://zmbank.kbstar.com/kbapplink?cmd=move_to&id=web&url=/mquics?page=C102688&urlparam=";
    }else{
      kbScheme = "https://mbank.kbstar.com/kbapplink?cmd=move_to&id=web&url=/mquics?page=C102688&urlparam=";
      // kbScheme = "https://zmbank.kbstar.com/?cmd=move_to&id=web&url=/mquics?page=C102688&urlparam=";
    }
  }else {
    kbScheme = "kbbank://call?cmd=move_to&id=web&url=/mquics?page=C102688&urlparam=";
  }
  // var kbScheme = "https://obank.kbstar.com/quics?page=C041244&scheme=kbbank&pageid=C102688&urlparam=";
  kbScheme += "serno:" + encodeURIComponent(encodeURIComponent(certid))  + ",";
  kbScheme += "reqTxId:" + encodeURIComponent(encodeURIComponent(reqid));
  return kbScheme;
}

function makePassData(){
  
  //통신사PASS인경우 앱 호출시에만 reqtxid 40자리중 위 20자리만 사용
  const reqid = Provider.isGov() ? Provider.reqTxId.substring(20, 40) : Provider.reqTxId;
  const telcoid = Provider.telcoTxid;
  const certid = Provider.cxId;
  const ostype = device.checkMobileType() ;
  var callscheme = "&callbackScheme=app2appdummy";  //설정값에 받아야함/
  var callurl = "&packageName=com.atoncorp.app2appdummy";//설정값에 받아야함/
  if(ostype == "IOS"){
    callscheme = "&callbackScheme=App2AppDummy";
    callurl = "&callBackUrl="+Provider.providerOptionInfo.callbackUrl;
  }
  callurl =  getTelcoData(reqid,telcoid,certid,callscheme,callurl);

  return callurl;
}

function getTelcoData(rid,tid,cid,calback,calurl) {
  //OS & Browser
  var ostype = device.checkMobileType() ;
  var bwtype =  Provider.deviceInfo.browser;
  var telcoTycd = Provider.userInfo.telcoTycd;
  //
  var skpName = "com.sktelecom.tauth";
  var skscheme = "tauthlink";
  var skhost = "certauth";
  var sk_universal_link = "";
  if(Config.uriScheme.mode.id == "dev"){
    sk_universal_link = "https://passhome-qa.minwise.co.kr/applink/certauth"; //개발
  }else{
    sk_universal_link = "https://www.sktpass.com/applink/certauth"; //운영
  }

  var lgupName = "com.lguplus.smartotp";
  var lguscheme = "upluscorporation";
  var lguhost = "";
  var lgu_universal_link = "";
  if(Config.uriScheme.mode.id == "dev"){
    lgu_universal_link = "https://fidotest.uplus.co.kr/rp/lgauthPass";  //개발
  }else{
    lgu_universal_link = "https://fido.uplus.co.kr/rp/lgauthPass";  //운영
  }
  
  // var ktpName = "kt.fido.sw.asm.api"; //개발 
  // var ktpName = "com.kt.kauth"; //운영
  var ktscheme = "ktpasslink20";
  var kthost = "requestSignCert";
  var kt_universal_link = "";
  if(Config.uriScheme.mode.id == "dev"){
    kt_universal_link = "https://tb.fido.kt.com/requestSignCert"; //개발
  }else{
    kt_universal_link = "https://fido.kt.com/requestSignCert"; //운영
  }

  var str = "";
  if(ostype == "IOS"){
      //universal_link
      if(telcoTycd == "S"){
        str = sk_universal_link + "?reqTxId="+rid+"&certTxId="+cid+"&telcoTxId="+tid;
      }else if (telcoTycd == "K"){
        str = kt_universal_link + "?reqTxId="+rid+"&certTxId="+cid+"&telcoTxId="+tid;
      }else if(telcoTycd == "L"){
        str = lgu_universal_link + "?reqTxId="+rid+"&certTxId="+cid+"&telcoTxId="+tid+"&sc=004";
      }
  }else{//AOS
    //URISCHEME
    //AOS SCHEME Data
      if(telcoTycd == "S"){
        str = skscheme+ "://"+skhost+"?reqTxId="+rid+"&telcoTxId="+tid+"&certTxId="+cid;
      }else if (telcoTycd == "K"){
        str = ktscheme+ "://"+kthost+"?reqTxId="+rid+"&telcoTxId="+tid+"&certTxId="+cid;
      }else if(telcoTycd == "L"){
        str = lguscheme+ "://?reqTxId="+rid+"&telcoTxId="+tid+"&certTxId="+cid+"&sc=004";
      }
  }
  //210407 아톤요청 WB 구분하여 콜백제거 -> 대상 WB , WBK
  if( bwtype != "WB"){
       str += calback+calurl;
  }//WB END
  return str;
}


/*
Sample

✔ 카카오
- IOS(Config.auth.json universalLink Option false):  kakaotalk://me/cert/sign?tx_id=
- IOS(Config.auth.json universalLink Option true):   https://talk-apps.kakao.com/scheme/
- AOS: kakaotalk://me/cert/sign?tx_id=

✔ 페이코 (  ${pay_session}는 cxId )
- IOS(Config.auth.json universalLink Option false):  payco://open/certificate?session=${pay_session}&signAfterExit=true
- IOS(Config.auth.json universalLink Option true):   https://paycoiosmarket.page.link/?link=https%3A%2F%2Fm.payco.com%3Fscheme%3Dpayco%253A%252F%252Fopen%252Fcertificate%253Fsession%3D${pay_session}&ibi=com.nhnent.TOASTPAY&isi=924292102&efr=1&ifl=https%3A%2F%2Fm.payco.com%2Fapp%2Fexec.nhn%3Fopen%3D%252Fcertificate%253Fsession%3D${pay_session}
- AOS: payco://open/certificate?session=${pay_session}&signAfterExit=true

✔ 통신사패스
- IOS SK: https://www.sktpass.com/applink/certauth?reqTxId=&certTxId=&telcoTxId=
- IOS KT: https://fido.kt.com/requestSignCert?reqTxId=&certTxId=&telcoTxId=
- IOS LG: https://fido.uplus.co.kr/rp/lgauthPass?reqTxId=&certTxId=&telcoTxId=&sc=004
- AOS SK: tauthlink://certauth?reqTxId=&telcoTxId=&certTxId=
- AOS KT: ktpasslink20://requestSignCert?reqTxId=&telcoTxId=&certTxId=
- AOS LG: upluscorporation://?reqTxId=&telcoTxId=&certTxId=&sc=004

✔ 삼성패스 (인증기관에서 URI 정보를 넘겨주는 형태 - 소스에 없음)
samsungpass://cert/sign?requestId=

✔ 토스 (인증기관에서 URI 정보를 넘겨주는 형태 - 소스에 없음)
supertoss://toss-cert/v2/sign/user/auth?txId=f1f2fe12-d392-4a74-9403-c1ed90ffd566&_minVerAos=5.36.0&_minVerIos=5.10.0

✔ 네이버
* AOS는 인증기관에서 URI 정보를 넘겨주는 형태 - 소스에 없음
* IOS는 인증기관에서 넘겨준 URI 정보를 인코딩한 파라메타로 새로운 https URL로 호출
- AOS 네이버앱: naversearchapp://naversign?apiType=profile&version=5&sessionKey=hE87bzhx3CnGAeAQVpn8N1kY3QycmuEi
- AOS 그외 모바일브라우저: naversearchapp://naversign?apiType=profile&version=5&sessionKey=hE87bzhx3CnGAeAQVpn8N1kY3QycmuEi&closeApp=true
- IOS 네이버엡 (Config.auth.json universalLink Option true): https://naverapp.m.naver.com/?urlScheme=${encodeURIComponent('naversearchapp://naversign?apiType=profile&version=5&sessionKey=hE87bzhx3CnGAeAQVpn8N1kY3QycmuEi')}
- IOS 네이버앱(Config.auth.json universalLink Option false): naversearchapp://naversign?apiType=profile&version=5&sessionKey=hE87bzhx3CnGAeAQVpn8N1kY3QycmuEi
- IOS 그외 모바일브라우저 (Config.auth.json universalLink Option true): https://naverapp.m.naver.com/?urlScheme=${encodeURIComponent('naversearchapp://naversign?apiType=profile&version=5&sessionKey=hE87bzhx3CnGAeAQVpn8N1kY3QycmuEi')}&closeApp=true
- IOS 그외 모바일브라우저(Config.auth.json universalLink Option false): naversearchapp://naversign?apiType=profile&version=5&sessionKey=hE87bzhx3CnGAeAQVpn8N1kY3QycmuEi&closeApp=true

✔ KB국민
- IOS: https://mbank.kbstar.com/kbapplink?cmd=move_to&id=web&url=/mquics?page=C102688&urlparam=
- AOS: kbbank://call?cmd=move_to&id=web&url=/mquics?page=C102688&urlparam= 

✔ 신한은행
- IOS: iphoneSbank://SHSIGN?tran_type_cd='sol_gov'&cert_tx_id=&sign_tx_id=
- AOS: sbankandnor://SHSIGN?tran_type_cd='sol_gov'&cert_tx_id=&sign_tx_id= */